export default __webpack_public_path__ + "static/media/14.9a331dcc.jpg";